export default "__VITE_ASSET__c1c3989b__"